import { render } from "./OcrListLegacy.vue?vue&type=template&id=690dc92c"
import script from "./OcrListLegacy.vue?vue&type=script&lang=js"
export * from "./OcrListLegacy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__